import React from "react";
import * as FaIcons from "react-icons/fa";
import * as FcIcons from "react-icons/fc";
import * as Fa6Icons from "react-icons/fa6";
import * as AiIcons from "react-icons/ai";
import * as IoIcons from "react-icons/io";
import * as RiIcons from "react-icons/ri";
import * as BSIcons from "react-icons/bs";
import * as MdIcons from "react-icons/md";
import * as BiIcons from "react-icons/bi";
import * as GiIcons from "react-icons/gi";
import * as BsIcons from "react-icons/bs";
import * as CgIcons from "react-icons/cg";

export const SidebarData = [
// userrole is an array that contains all the role ids who are allowed to see each menu
// all menus and submenus must have the property userrole
{
	userrole: [1,2,3,4,5,6],
	title: "FAST QUOTES",
	icon: <RiIcons.RiFileTransferFill />,
	iconClosed: <RiIcons.RiArrowDownSFill />,
	iconOpened: <RiIcons.RiArrowUpSFill />,
	path: "/fast-quote",			
},
{
	userrole: [1,2,3,4,5,6],
	title: "LISTS",	
	icon: <FaIcons.FaListAlt />,
	iconClosed: <RiIcons.RiArrowDownSFill />,
	iconOpened: <RiIcons.RiArrowUpSFill />,

	subNav: [	
		{
			userrole: [1,3],
			title: "Items",	
			icon: <BsIcons.BsBoxSeamFill />,
			iconClosed: <RiIcons.RiArrowDownSFill />,
			iconOpened: <RiIcons.RiArrowUpSFill />,
			path: "/items",
		},
		{
			userrole: [1,3],
			title: "Brands & Colors",	
			icon: <BsIcons.BsBoxSeamFill />,
			iconClosed: <RiIcons.RiArrowDownSFill />,
			iconOpened: <RiIcons.RiArrowUpSFill />,
			path: "/items",
		},		
		{
			userrole: [1,2,3,4,5,6],
			title: "UOMs",	
			icon: <GiIcons.GiWeight />,
			iconClosed: <RiIcons.RiArrowDownSFill />,
			iconOpened: <RiIcons.RiArrowUpSFill />,
			path: "/uoms",
		},		
		{
			userrole: [1,2,3,4,5,6],
			title: "Clients",	
			icon: <BSIcons.BsPersonCircle />,
			iconClosed: <RiIcons.RiArrowDownSFill />,
			iconOpened: <RiIcons.RiArrowUpSFill />,
			path: "/clients",
		},
		{
			userrole: [1,2,3,4,5,6],
			title: "Jobs",	
			icon: <BSIcons.BsPersonCircle />,
			iconClosed: <RiIcons.RiArrowDownSFill />,
			iconOpened: <RiIcons.RiArrowUpSFill />,
			path: "/jobs",
		}		
	]	
},
{
	userrole: [1],
	title: "DASHBOARD",
	path: "/dashboard",
	icon: <BiIcons.BiSolidDashboard />,
	iconClosed: <RiIcons.RiArrowDownSFill />,
	iconOpened: <RiIcons.RiArrowUpSFill />,
},
{
	userrole: [3],
	title: "ADMIN",
	icon: <BsIcons.BsFillGearFill />,
	iconClosed: <RiIcons.RiArrowDownSFill />,
	iconOpened: <RiIcons.RiArrowUpSFill />,

	subNav: [	
		{
			userrole: [3],
			title: "SETTINGS",
			path: "/admin-settings",
			icon: <AiIcons.AiFillSetting />,
		},
		{
			userrole: [3],
			title: "MANAGE USERS",
			path: "/admin-users",
			icon: <RiIcons.RiUserSettingsFill />,
		}		
	]	
},

{
	userrole: [1],
	title: "HELP",
	path: "/help",
	icon: <IoIcons.IoMdHelpCircle />,
},
];
